import { authAddress } from "../config";
import handleResponse from "./handleResponse";

const base_user_url = "/api/v1/auth";

const full_base_path = authAddress + base_user_url;

export const login = (username, password) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
        "username": username,
        "password": password
    });

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
    };

    return fetch(full_base_path + "/login/authenticate", requestOptions)
}

export const registration = (username, mail, password) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
        "username": username,
        "password": password,
        "mail": mail
    });

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
    };

    return fetch(full_base_path + "/registration", requestOptions)
}

export const checkTokenExpiry = (token) => {

    const requestOptions = {
        method: "GET",
        redirect: "follow"
    }

    return fetch(full_base_path + "/login/evaluateToken/" + token, requestOptions)
    .then(response => {
        return handleResponse(response)
    }).then(response => {
        return response.json();
    });
}

export const checkNameAvailability = (name) => {


    const requestOptions = {
        method: "GET",
        redirect: "follow"
    }

    return fetch(full_base_path + "/registration/checkName/" + name, requestOptions)
    .then(response => {
        return handleResponse(response)
    }).then(response => {
        return response.text()
    }).catch(
        error => {
            console.log(error);
            return false;
        }
    );
}

export const checkMailAvailability = (mail) => {

    const requestOptions = {
        method: "GET",
        redirect: "follow"
    }

    return fetch(full_base_path + "/registration/checkMail/" + mail, requestOptions)
    .then(response => {
        return handleResponse(response)
    }).then(response => {
        return response.json()
    }).catch(
        error => {
            console.log(error);
            return false;
        }
    );
}

export const mailLogin = (mail) => {
    const requestOptions = {
        method: "PUT",
        redirect: "follow"
    }
    
    return fetch(full_base_path + "/login/authenticate/mail/" + mail, requestOptions)
    .then(response => handleResponse(response))
    .catch(error => console.log(error))

}